import useBundleTranslation from 'i18n';
import { Box } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import useSystemDateTime from 'hooks/useSystemDateTime';

const REFETCH_INTERVAL_MS = 30000;

export function SystemDateTimeLabel() {
    const { t } = useBundleTranslation(['app/notification/my-notification']);
    const { data } = useSystemDateTime(REFETCH_INTERVAL_MS);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
            }}
        >
            {!data ? (
                <>
                    <IconMi icon={'clock'} fontSize={'16'} sx={{ mx: 1 }} /> {t('loading___')}
                </>
            ) : (
                <>
                    {`${data.systemDate} ${t('system')}`}
                    <IconMi icon={'clock'} fontSize={'16'} sx={{ mx: 1 }} />
                    {`${data.systemTime}`}
                </>
            )}
        </Box>
    );
}
